import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import GoogleMapReact from 'google-map-react';
// components
import { Skeleton } from '@mui/material';
import Iconify from 'src/commons/components/iconify';

const Marker = () => (
  <Iconify icon="fa6-solid:map-pin" width={42} sx={{ color: 'green.primary', zIndex: 99 }} />
);

const StoreMap = ({ name = '', latitude, longitude, isLoading = false }) => {
  const defaultProps = {
    center: {
      lat: latitude,
      lng: longitude,
    },
    zoom: 17,
  };

  return (
    <>
      {!isLoading && (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        >
          <Marker lat={latitude} lng={longitude} />
        </GoogleMapReact>
      )}
      {isLoading && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="100%"
          height="55vh"
          sx={{ bgcolor: 'grey.100' }}
        />
      )}
    </>
  );
};

StoreMap.propTypes = {
  name: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  isLoading: PropTypes.bool,
};

export default StoreMap;
